import { UAParser as uaParser } from 'ua-parser-js';

export const getDeviceOs = () => {
    const UAParser = new uaParser();
    const userAgent = window.navigator.userAgent;
    const getOSData = UAParser.setUA(userAgent).getOS();

    return getOSData?.name;
};
